import { render, staticRenderFns } from "./ServiceTypeLalamove.vue?vue&type=template&id=6a519208&"
import script from "./ServiceTypeLalamove.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeLalamove.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypeLalamove.vue?vue&type=style&index=0&id=6a519208&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports